import {getAllChatBuddyListRequest} from "./BuddyListAPI";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RootState} from "../../../../store";
import {ChatBuddyProps} from "../../../Models/ChatBuddyProps";

// Define a type for the slice state
interface CounterState {
    isFetching: boolean,
    error: {} | null,
    status: 'IDLE' | "PENDING" | "SUCCESS" | 'FAILED'
    buddyList:ChatBuddyProps[]
}

// Define the initial state using that type
const initialState: CounterState = {
    isFetching: false,
    status: "IDLE",
    buddyList: [],
    error:null
}


export const getAllBuddyChatList = createAsyncThunk(
    'buddyList/chat',
    async (id : any) => {
        return await getAllChatBuddyListRequest(id)
    }
)

// Then, handle actions in your reducers:
// Then, handle actions in your reducers:
const buddyListSlice = createSlice({
    name: 'getAllBuddyChatList',
    initialState: initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        clearGetAllBuddyList: (state) => {
            state.isFetching = false    
            state.status = "IDLE"
            state.buddyList =[]
            state.error=null
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(getAllBuddyChatList.pending, (state) => {
                state.status = 'PENDING';
                state.isFetching = true;
            })
            .addCase(getAllBuddyChatList.fulfilled, (state, action) => {
                // Add user to the state array
                state.status = 'SUCCESS';
                state.isFetching = false;
                state.buddyList = action.payload;
            })
            .addCase(getAllBuddyChatList.rejected, (state) => {
                state.status = 'FAILED';
                state.isFetching = false;
                state.error = state
            })
    },
})

export const getAllBuddyListSelector = (state: RootState) => state.getListofChatBuddyList;

export const {clearGetAllBuddyList} = buddyListSlice.actions
export default buddyListSlice.reducer
